export default __webpack_public_path__ + "static/media/newsImg1.e62bb976.jpg";